export default __webpack_public_path__ + "static/media/ag.c2293c7d.svg";